import { cn } from "../../lib/utils";
interface CheckCircleIconProps {
  className?: string;
}

const CheckCircleIcon = ({ className }: CheckCircleIconProps) => {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="#01AB6D"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-5 2xl:size-6", className)}
    >
      <path d="M6.05392 9.83592L10.5359 5.35391L9.83342 4.65142L6.05392 8.43092L4.15392 6.53092L3.45141 7.23342L6.05392 9.83592ZM7.00125 13.3334C6.12525 13.3334 5.30186 13.1672 4.53108 12.8347C3.7603 12.5023 3.08986 12.0511 2.51975 11.4812C1.94964 10.9114 1.49825 10.2412 1.16558 9.47075C0.833026 8.7003 0.666748 7.87714 0.666748 7.00125C0.666748 6.12525 0.83297 5.30186 1.16541 4.53108C1.49786 3.7603 1.94903 3.08986 2.51891 2.51975C3.0888 1.94964 3.75897 1.49825 4.52941 1.16558C5.29986 0.833026 6.12303 0.666748 6.99891 0.666748C7.87492 0.666748 8.6983 0.83297 9.46908 1.16541C10.2399 1.49786 10.9103 1.94903 11.4804 2.51891C12.0505 3.0888 12.5019 3.75897 12.8346 4.52941C13.1671 5.29986 13.3334 6.12303 13.3334 6.99891C13.3334 7.87492 13.1672 8.6983 12.8347 9.46908C12.5023 10.2399 12.0511 10.9103 11.4812 11.4804C10.9114 12.0505 10.2412 12.5019 9.47075 12.8346C8.7003 13.1671 7.87714 13.3334 7.00125 13.3334Z" />
    </svg>
  );
};

export default CheckCircleIcon;
